(function () {
    'use strict';

    angular
        .module('adm')
        .controller('ExpensesComparativeDetailsController', ExpensesComparativeDetailsController);

    ExpensesComparativeDetailsController.$inject = ['$uibModalInstance', '$state', 'items', 'semesterA', 'semesterB'];

    function ExpensesComparativeDetailsController($uibModalInstance, $state, items, semesterA, semesterB) {
        var vm = this;
        vm.activate                         = activate;
        vm.ok                               = ok;
        vm.cancel                           = cancel;
        vm.items                            = items;
        vm.semesterA                        = semesterA;
        vm.semesterB                        = semesterB;

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function activate() {

        }
        vm.activate();
    }

})();